import { componentProvider } from 'js-component-framework';
import FilterMilestones from './filter-milestones';

const FilterMilestonesConfig = {
  name: 'filter-milestones',
  component: FilterMilestones,
  querySelector: {},
  querySelectorAll: {},
  options: {
    hide: 'snc-hide',
    linkActive: 'snc-active',
  },
};

componentProvider(FilterMilestonesConfig);
